export const POST_REFERSH_TOKEN = '/api/auth/token/refresh';
export const GET_REGISTER_BY_PHONE = '/api/auth/register';
export const POST_REGISTER_BY_PHONE = '/api/auth/register-lite';
export const POST_REGISTER_CONTACT_INFO = '/api/auth/register/{registerId}/1';
export const GET_REGISTER_INFO = '/api/auth/register/{registerId}';

// /business-api/auth/register/$registerId/resend-sms
